import * as Yup from 'yup'
import {
  AsyncCarModel,
  AsyncCustomerModel,
  AsyncReservationSourceModel,
  AsyncVehicleGroupModel,
  BaseEntity,
} from '../../../shared/models/ApiModels'
import {SubTabOption} from '../../../shared/components/SubTabHeader'

const getCurrentTime = () => {
  const now = new Date()
  const hours = now.getHours().toString().padStart(2, '0')
  const minutes = now.getMinutes().toString().padStart(2, '0')
  return `${hours}:${minutes}`
}

export interface IReservationModel extends BaseEntity {
  // Hızlı Giriş
  customer: AsyncCustomerModel | null
  customerId: string
  customerFullName: string
  status: string
  reservationDate: Date
  fileNumber1: string
  fileNumber2: string
  flightNumber: string
  startDate: Date
  startTime: string
  endDate: Date
  endTime: string
  rentalDay: number
  pickupBranch: string
  pickupBranchId: string
  pickupBranchName: string
  pickupBranchNote: string
  returnBranch: string
  returnBranchId: string
  returnBranchName: string
  returnBranchNote: string
  rentalType: string
  billingType: string
  customerCompany: AsyncCustomerModel | null
  customerCompanyId: string
  calculationType: string
  currency: string
  price: number
  discount: number
  priceAfterDiscount: number
  vehicleGroup: AsyncVehicleGroupModel | null
  vehicleGroupId: string
  reservationSource: AsyncReservationSourceModel | null
  reservationSourceId: string
  deliveredPersonelId: string
  car: AsyncCarModel | null
  carId: string
  carPlate: string
  brandName: string
  modelType: string
  transmission: string
  fuelType: string
  rentalAmount: string
  additionalServiceAmount: string
  subTotalAmount: string
  taxAmount: string
  totalAmount: number
  generalTotalWithCurrency: string
  remainingAmount: string
  remainingCurrency: string

  // Rez.Bilgisi / Teslimat
  startDate1: Date
  startTime1: string
  endDate1: Date
  endTime1: string
  branch: string
  reservedPersonelId: string
  optionType: string
  optionDay: number
  optionDate: string
  giftDay: string
  expectedDay: number

  // Müşteri Bilgileri
  phone: string
  email: string
  driverLicenseNo: string
  tcIdentityNo: string
  reservationSourceDetail: AsyncReservationSourceModel | null
  secondReservationSource: AsyncReservationSourceModel | null
  secondReservationSourceId: string

  // Araç / Grup
  vehicleGroup1: AsyncVehicleGroupModel | null
  deliveredVehicleGroup: AsyncVehicleGroupModel | null
  carDetail: AsyncCarModel | null
  carInfo: string
  modelTypeDetail: string
  transmissionDetail: string
  carDetails: string
  brandNameDetail: string
  modelYear: string
  fuelTypeDetail: string
  fullness: string
  carLocation: string

  // Fiyat / Toplam
  pricingType: string
  price1: number
  discount1: number
  priceAfterDiscount1: number
  currency1: string
  autoDescription: string
  deliveryType: string
  tariffId: string
  campaign: string
  campaignCondition: string
  customVatRate: string
  promotionCode: string
  promotionAmount: number
  promotionCurrency: string
  rentAmount1: string
  serviceAmount1: string
  kdvTl1: string
  totalAmount1: string
  grandTotal: string
  collection: string
  remaining1: string
  remainingCurrency1: string
  hourDifferenceTaken: boolean
  paymentMethod: string

  //Additional Services
  customerAdd: string
  pickupBranchAdd: string
  returnBranchAdd: string
  priceAdd: number
  generalCurrencyAdd: string
  startDateAdd: Date
  startTimeAdd: string
  rentDayAdd: number
  plateAdd: string
  calculateTypeAdd: string
  endDateAdd: Date
  endTimeAdd: string
  vehicleGroupAdd: string
  totalAmountAdd: number
  remainingAmountAdd: string
  currencyAdd: string
  additionalCurrencyAdd: string
  additionalServiceSellOwner: string
  additionalServices: IAdditionalServiceModel[] | null

  // Ayrıntılar
  explanation: string
  // Account & flight info
  accountOwner: string
  accountNo: string
  arrivalDate: Date | null
  arrivalTime: string
  flightDate: Date | null
  returnFlightNo: string
  returnDate: Date | null
  returnTime: string
  security: string

  // Drivers
  driverFirst: DriverModel
  driverSecond: DriverModel

  // Other Info
  manualFindexScore: string
  guarantor: string
  customerVehicle: string
  warningDescription: string
  vehicleDetails: string
  specialCode: string
  requestType: string
  companyCode: string
  requestSourceUnit: string
  approvalCode: string
  projectName: string
  riskPermissionLevel: string

  // Broker Info
  incomingRent: string
  incomingDrop: string
  incomingExtra: string
  incomingPayment: string
}

export const additionalList: IAdditionalServiceModel[] = [
  {
    name: 'BABY_SEAT',
    isAdd: false,
    title: 'Bebek Koltuğu',
    isDaily: true,
    hasPiece: true,
    piece: 1,
    price: 0,
    hasProduct: true,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'CHILD_SEAT',
    isAdd: false,
    title: 'Çocuk Koltuğu',
    isDaily: true,
    hasPiece: true,
    piece: 1,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'NAVIGATION',
    isAdd: false,
    title: 'Navigasyon',
    isDaily: true,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'EXTRA_DRIVER',
    isAdd: false,
    title: 'Ek Sürücü',
    isDaily: true,
    hasPiece: true,
    piece: 1,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'CDW',
    isAdd: false,
    title: 'Muafiyetli Sigorta (CDW)',
    isDaily: true,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'LCF',
    isAdd: false,
    title: 'Lastik/Cam/Far Sigortası',
    isDaily: true,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'MINI_DAMAGE',
    isAdd: false,
    title: 'Mini Hasar Sigortası',
    isDaily: true,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'MAX_SECURITY',
    isAdd: false,
    title: 'Max Güvence Paketi',
    isDaily: true,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'SUPER_MINI_DAMAGE',
    isAdd: false,
    title: 'Süper Mini Hasar Sigortası',
    isDaily: true,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'SCDW',
    isAdd: false,
    title: 'SCDW',
    isDaily: true,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'PERSONAL_ACCIDENT',
    isAdd: false,
    title: 'Ferdi Kaza',
    isDaily: true,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'WIFI',
    isAdd: false,
    title: 'Wifi',
    isDaily: true,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'YOUNG_DRIVER',
    isAdd: false,
    title: 'Genç Sürücü Paketi',
    isDaily: true,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'IMM',
    isAdd: false,
    title: 'İhtiyari Mali Mesuliyet',
    isDaily: true,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'CHARGER',
    isAdd: false,
    title: 'Şarj Cihazı',
    isDaily: true,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'PASS_FEE',
    isAdd: false,
    title: 'Geçiş Bedeli',
    isDaily: false,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: false,
    status: 'NRM',
  },
  {
    name: 'EXTRA_KM',
    isAdd: false,
    title: 'Ek KM',
    isDaily: false,
    hasPiece: true,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'DELIVERY',
    isAdd: false,
    title: 'Adrese Teslim',
    isDaily: false,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: false,
    status: 'NRM',
  },
  {
    name: 'DROP_FEE',
    isAdd: false,
    title: 'Drop Bedeli',
    isDaily: false,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: false,
    status: 'NRM',
  },
  {
    name: 'WINTER_TIRE',
    isAdd: false,
    title: 'Kış Lastiği',
    isDaily: false,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'MEMBERSHIP',
    isAdd: false,
    title: 'Üyelik / Hizmet Bedeli',
    isDaily: false,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'CANCEL_PACKAGE',
    isAdd: false,
    title: 'İptal Güvence Paketi',
    isDaily: true,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'EXTRA_SERVICE_1',
    isAdd: false,
    title: '1. Ek Hizmet(Serbest)',
    isDaily: false,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: false,
    status: 'NRM',
  },
  {
    name: 'FULL_COVERAGE',
    isAdd: false,
    title: 'Full Coverage',
    isDaily: true,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: false,
    status: 'NRM',
  },
  {
    name: 'EXTRA_SERVICE_3',
    isAdd: false,
    title: '3. Ek Hizmet',
    isDaily: false,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'EXTRA_SERVICE_4',
    isAdd: false,
    title: '4. Ek Hizmet',
    isDaily: false,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: true,
    status: 'NRM',
  },
  {
    name: 'RENT_DIFFERENT',
    isAdd: false,
    title: 'Kira Farkı',
    isDaily: false,
    hasPiece: false,
    piece: 0,
    price: 0,
    hasProduct: false,
    productNumber: '',
    productOwner: '',
    totalPrice: 0,
    hasStatus: false,
    status: 'NRM',
  },
]

export const initialReservation: IReservationModel = {
  // Hızlı Giriş
  customer: null,
  customerId: '',
  customerFullName: '',
  status: '0',
  reservationDate: new Date(),
  fileNumber1: '',
  fileNumber2: '',
  flightNumber: '',
  startDate: new Date(),
  startTime: getCurrentTime(),
  endDate: (() => {
    const d = new Date()
    d.setDate(d.getDate() + 1)
    return d
  })(),
  endTime: getCurrentTime(),
  rentalDay: 1,
  pickupBranch: '',
  pickupBranchId: '',
  pickupBranchName: '',
  pickupBranchNote: '',
  returnBranch: '',
  returnBranchId: '',
  returnBranchName: '',
  returnBranchNote: '',
  rentalType: '0',
  billingType: '0',
  customerCompany: null,
  customerCompanyId: '',
  calculationType: '1',
  currency: 'a6bb38bf-b3d2-4d78-bf73-f5e602600f9b',
  price: 0,
  discount: 0,
  priceAfterDiscount: 0,
  vehicleGroup: null,
  vehicleGroupId: '',
  car: null,
  carId: '',
  carPlate: '',
  reservationSource: null,
  reservationSourceId: '',
  deliveredPersonelId: '',
  brandName: '',
  modelType: '',
  transmission: '',
  fuelType: '',
  rentalAmount: '',
  additionalServiceAmount: '',
  subTotalAmount: '',
  taxAmount: '',
  totalAmount: 0,
  generalTotalWithCurrency: '',
  remainingAmount: '0',
  remainingCurrency: 'a6bb38bf-b3d2-4d78-bf73-f5e602600f9b',

  // Rez.Bilgisi / Teslimat
  startDate1: new Date(),
  startTime1: getCurrentTime(),
  endDate1: (() => {
    const d = new Date()
    d.setDate(d.getDate() + 1)
    return d
  })(),
  branch: '',
  endTime1: getCurrentTime(),
  reservedPersonelId: '',
  optionType: '',
  optionDay: 0,
  optionDate: '',
  giftDay: '',
  expectedDay: 1,

  // Müşteri Bilgileri
  phone: '',
  email: '',
  driverLicenseNo: '',
  tcIdentityNo: '',
  reservationSourceDetail: null,
  secondReservationSource: null,
  secondReservationSourceId: '',

  // Araç / Grup
  vehicleGroup1: null,
  deliveredVehicleGroup: null,
  carDetail: null,
  brandNameDetail: '',
  modelTypeDetail: '',
  transmissionDetail: '',
  fuelTypeDetail: '',
  carDetails: '',
  carInfo: '',
  modelYear: '',
  fullness: '',
  carLocation: '',

  // Fiyat / Toplam
  pricingType: '1',
  price1: 0,
  discount1: 0,
  priceAfterDiscount1: 0,
  currency1: 'a6bb38bf-b3d2-4d78-bf73-f5e602600f9b',
  autoDescription: '',
  deliveryType: '0',
  tariffId: '',
  campaign: '',
  campaignCondition: '',
  promotionCode: '',
  promotionAmount: 0,
  promotionCurrency: '',
  customVatRate: '',
  rentAmount1: '',
  serviceAmount1: '',
  kdvTl1: '',
  totalAmount1: '',
  grandTotal: '',
  collection: '0',
  remaining1: '',
  remainingCurrency1: 'a6bb38bf-b3d2-4d78-bf73-f5e602600f9b',
  hourDifferenceTaken: true,
  paymentMethod: '0',

  //Additional Services
  customerAdd: '',
  pickupBranchAdd: '',
  returnBranchAdd: '',
  priceAdd: 0,
  generalCurrencyAdd: 'TL',
  startDateAdd: new Date(),
  startTimeAdd: getCurrentTime(),
  rentDayAdd: 0,
  plateAdd: '',
  calculateTypeAdd: 'KDV Günlük Dahil',
  endDateAdd: (() => {
    const d = new Date()
    d.setDate(d.getDate() + 1)
    return d
  })(),
  endTimeAdd: getCurrentTime(),
  vehicleGroupAdd: '',
  totalAmountAdd: 0,
  remainingAmountAdd: '0',
  currencyAdd: 'TL',
  additionalCurrencyAdd: 'a6bb38bf-b3d2-4d78-bf73-f5e602600f9b',
  additionalServiceSellOwner: '', 
  additionalServices: additionalList.map(service => ({
    name: service.name,
    isAdd: false,
    title: service.title,
    isDaily: service.isDaily,
    hasPiece: service.hasPiece,
    piece: 0,
    price: 0,
    hasProduct: service.hasProduct,
    productNumber: '',
    productOwner: '0',
    totalPrice: 0,
    hasStatus: true,
    status: '0'
  })),

  // Ayrıntılar
  explanation: '',

  //Flight Info
  accountOwner: '',
  accountNo: '',
  arrivalDate: null,
  arrivalTime: '',
  flightDate: null,
  returnFlightNo: '',
  returnDate: null,
  returnTime: '',
  security: '',
  
  //Driver Info
  driverFirst: {
    driver: null, 
    fullName: '',
    phone: '',
    tckn: '',
    licenseNo: '',
    name: '',
    surname: '',
    licensePlace: '',
    licenseDate: null,
    birthDate: null,
  },

  driverSecond: {
    driver: null,
    fullName: '',
    phone: '',
    tckn: '',
    licenseNo: '',
    name: '',
    surname: '',
    licensePlace: '',
    licenseDate: null,
    birthDate: null,
  },

  //Other Info
  manualFindexScore: '',
  guarantor: '',
  customerVehicle: '',
  warningDescription: '',
  vehicleDetails: '',
  specialCode: '',
  requestType: '',
  companyCode: '',
  requestSourceUnit: '',
  approvalCode: '',
  projectName: '',
  riskPermissionLevel: '0',

  //Drop Info
  incomingRent: '',
  incomingDrop: '',
  incomingExtra: '',
  incomingPayment: '0',
}

export const validationReservation = Yup.object().shape({
  //customer: Yup.string().nullable().required('Cari bilgisi zorunludur'),
  // Tarihler ve saatler
  startDate: Yup.date().required('Başlangıç tarihi zorunludur'),
  startTime: Yup.string().required('Başlangıç saati zorunludur'),
  endDate: Yup.date().required('Beklenen tarih zorunludur'),
  endTime: Yup.string().required('Beklenen saat zorunludur'),

  // Ofis seçimleri
  //pickupBranchId: Yup.string().required('Çıkış ofisi zorunludur'),
  //returnBranchId: Yup.string().required('Dönüş ofisi zorunludur'),
  //vehicleGroup: Yup.string().nullable().required('Araç grubu zorunludur'),

  // Durum & Tarih
  status: Yup.string().required('Rezervasyon durumu zorunludur'),
  reservationDate: Yup.string().required('Rezervasyon Tarihi zorunludur'),
  //rentalType: Yup.string().required('Kiralama Türü zorunludur'),
  //paymentType: Yup.string().required('Ödeme Türü zorunludur'),
  //calculationType: Yup.string().required('Hesaplama Tipi zorunludur'),
  //currency: Yup.string().required('Döviz Bilgisi zorunludur'),

  // Fiyat bilgileri
  price: Yup.number()
    .typeError('Fiyat sayı olmalıdır')
    .required('Fiyat zorunludur')
    .min(0, 'Negatif olamaz'),
  discount: Yup.number().typeError('İndirim sayı olmalıdır').min(0, 'Negatif olamaz'),
  //remaining: Yup.number().typeError('Kalan tutar sayı olmalıdır').min(0, 'Negatif olamaz'),
})

export interface DriverModel {
  driver: AsyncCustomerModel | null
  fullName: string
  phone: string
  tckn: string
  licenseNo: string,
  name: string,
  surname: string,
  licensePlace: string,
  licenseDate: Date | null,
  birthDate: Date | null,
}

export interface IReservationFilterModel {
  customerId: string | null
  reservationNo: string | null
  carId: string | null
  status: string | null
  dateFilterType: number | null
  startDate: Date | null
  endDate: Date | null
  customerCompanyId: string | null
  vehicleGroupId: string | null
  officeFilterType: number | null
  officeIdList: string[] // boş array gönderilebilir
}

export const initialReservationFilter: IReservationFilterModel = {
  customerId: null,
  reservationNo: null,
  carId: null,
  status: null,
  dateFilterType: null,
  startDate: new Date(),
  endDate: (() => {
    const d = new Date()
    d.setDate(d.getDate() + 365)
    return d
  })(),
  customerCompanyId: null,
  vehicleGroupId: null,
  officeFilterType: 0,
  officeIdList: [],
}

export const validationReservationFilter = Yup.object().shape({})

export const OFFICE_FILTER_TYPE = [
  {value: '0', label: 'Ofis Önemsiz'},
  {value: '1', label: 'İşlem Ofisi'},
  {value: '2', label: 'Çıkış Ofisi'},
  {value: '3', label: 'Dönüş Ofisi'},

] as const

export const PRODUCT_OWNER = [
  {value: '0', label: 'Bizim'},
  {value: '1', label: 'Dış Hizmet'},
] as const

export const ADDITIONAL_SERVICE_STATUS = [{value: '0', label: 'NRM'}] as const

export interface IAdditionalServiceModel {
  name: string
  isAdd: boolean
  title: string
  isDaily: boolean
  hasPiece: boolean
  piece: number
  price: number
  hasProduct: boolean
  productNumber: string
  productOwner: string
  totalPrice: number
  hasStatus: boolean
  status: string
}

export const reservationSubTabOptions: SubTabOption<
  'desc' | 'flight' | 'drivers' | 'other' | 'broker'
>[] = [
  {key: 'desc', title: 'Açıklama', icon: 'bi bi-card-text'},
  {key: 'flight', title: 'Finans/Uçuş', icon: 'bi bi-clipboard-data'},
  {key: 'drivers', title: 'Sürücüler', icon: 'bi bi-speedometer2'},
  {key: 'other', title: 'Diğer Bilgiler', icon: 'bi bi-tools'},
  {key: 'broker', title: 'Broker Bilgisi', icon: 'bi bi-cash-stack'},
]
